import { useQuery } from "@tanstack/react-query";
import { vehiclesService } from "@/features/vehicle/services";

export type FleetStats = {
	total: number;
	inOperation: number;
	inMaintenance: number;
	outOfOperation: number;
};

export const useFleetStats = () =>
	useQuery<FleetStats>({
		queryKey: ["fleet-stats"],
		queryFn: async () => {
			const data = await vehiclesService.getStats();
			return {
				total: data.total,
				inOperation: data.available,
				inMaintenance: data.inMaintenance,
				outOfOperation: data.inactive,
			};
		},
	});
